import { motion } from 'framer-motion'
import { navLinks } from './Navbar'
import { NavLink } from 'react-router-dom'
import { useEffect } from 'react'
import { MdClose } from 'react-icons/md'
type MobileSidebarProps = {
  isOpen: boolean
  onClose: () => void
}
export const MobileSidebar = ({ onClose, isOpen }: MobileSidebarProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])
  return (
    <motion.aside
      initial={{ x: '-100%' }}
      animate={{ x: '0%' }}
      exit={{ opacity: '-100%' }}
      transition={{
        type: 'tween',
      }}
      className="fixed top-0 z-50 h-screen w-full bg-[#333333] p-[40px] "
    >
      <div className="relative flex size-full items-center justify-center ">
        <MdClose
          size={40}
          className="absolute right-0 top-0  text-white"
          onClick={onClose}
        />

        <ul className="flex flex-col gap-y-[24px] text-center">
          {navLinks.map(({ name, path }, index) => (
            <NavLink
              to={path}
              key={index}
              onClick={onClose}
              className={({ isActive }) =>
                isActive
                  ? 'font-nunito text-[24px] font-normal leading-[32.74px]  text-[#8C1D40]'
                  : 'font-nunito text-[24px] font-normal leading-[32.74px] text-[#F5F5F5]'
              }
            >
              {name}
            </NavLink>
          ))}
        </ul>
      </div>
    </motion.aside>
  )
}
